'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createClient = undefined;

var _schemas = require('./schemas');

var _eventPool = require('./eventPool');

var eventPoolInterface = _interopRequireWildcard(_eventPool);

var _event = require('./event');

var eventInterface = _interopRequireWildcard(_event);

var _dictionary = require('./dictionary');

var dictionaryInterface = _interopRequireWildcard(_dictionary);

var _identifiers = require('./identifiers');

var identifiersInterface = _interopRequireWildcard(_identifiers);

var _metaProperties = require('./metaProperties');

var metaPropertiesInterface = _interopRequireWildcard(_metaProperties);

var _tracker = require('./tracker');

var trackerInterface = _interopRequireWildcard(_tracker);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var createClient = exports.createClient = function createClient() {
  var dependencies = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  /*
   * Step 1: Normalize & validate client dependencies
   */
  var parsedDependencies = _schemas.clientDependenciesSchema.normalize(dependencies);
  _schemas.clientDependenciesSchema.validate(parsedDependencies, '"createClient"', function (err) {
    /* Rethrow to break execution thread */
    throw err;
  });

  /*
   * Step 2: Build the client with those dependencies
   */
  var getDebug = parsedDependencies.getDebug,
      getEmail = parsedDependencies.getEmail,
      getHubId = parsedDependencies.getHubId,
      getHstc = parsedDependencies.getHstc,
      getLang = parsedDependencies.getLang,
      getTempStorage = parsedDependencies.getTempStorage,
      setTempStorage = parsedDependencies.setTempStorage,
      send = parsedDependencies.send,
      reportError = parsedDependencies.reportError,
      logMessage = parsedDependencies.logMessage,
      logError = parsedDependencies.logError;

  var eventPool = eventPoolInterface.createEventPool({
    getTempStorage: getTempStorage,
    setTempStorage: setTempStorage
  });
  var sendToNetwork = function sendToNetwork(_ref, events) {
    var identifiers = _ref.identifiers,
        _ref$isBeforeUnload = _ref.isBeforeUnload,
        isBeforeUnload = _ref$isBeforeUnload === undefined ? false : _ref$isBeforeUnload,
        _ref$isExternalHost = _ref.isExternalHost,
        isExternalHost = _ref$isExternalHost === undefined ? false : _ref$isExternalHost;

    var isAuthed = !!(identifiers.raw.email && identifiers.raw.hubId);
    var query = 'clientSendTimestamp=' + Date.now();
    if (isExternalHost) {
      query = query + '&dil=true';
    }
    send({
      events: events,
      isBeforeUnload: isBeforeUnload,
      isAuthed: isAuthed,
      query: query
    });
  };
  var flushPoolAndSendToNetwork = function flushPoolAndSendToNetwork(_ref2) {
    var identifiers = _ref2.identifiers;

    var events = eventPool.flush();
    if (events && events.length) {
      sendToNetwork({ identifiers: identifiers }, events);
    }
  };
  var sendToPool = function sendToPool(_ref3, event) {
    var identifiers = _ref3.identifiers;

    if (!eventPool.getIsInitialized()) {
      eventPool.initialize({
        normalizeEvent: function normalizeEvent() {
          for (var _len = arguments.length, rest = Array(_len), _key = 0; _key < _len; _key++) {
            rest[_key] = arguments[_key];
          }

          return eventInterface.normalizeIdentifiers.apply(eventInterface, [identifiers].concat(rest));
        }
      });
    }
    eventPool.push(event);
    eventPoolInterface.scheduleFlush(function () {
      return flushPoolAndSendToNetwork({ identifiers: identifiers });
    });
  };
  var sendToClient = function sendToClient(_ref4) {
    var bypassPool = _ref4.bypassPool,
        isBeforeUnload = _ref4.isBeforeUnload,
        isExternalHost = _ref4.isExternalHost;
    var identifiers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var event = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (bypassPool || isBeforeUnload) {
      sendToNetwork({
        identifiers: identifiers,
        isBeforeUnload: isBeforeUnload,
        isExternalHost: isExternalHost
      }, [event]);
    } else {
      sendToPool({
        identifiers: identifiers
      }, event);
    }
  };
  var getMetaProperties = function getMetaProperties() {
    return metaPropertiesInterface.getMetaProperties({
      getTempStorage: getTempStorage,
      setTempStorage: setTempStorage
    });
  };
  var createEventPayload = function createEventPayload() {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return eventInterface.createEventPayload.apply(eventInterface, [{
      metaProperties: getMetaProperties()
    }].concat(args));
  };

  return {
    createTracker: function createTracker() {
      for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return trackerInterface.createLockedTracker.apply(trackerInterface, [{
        parseDefinitions: dictionaryInterface.parseDefinitions,
        lookupDefinition: dictionaryInterface.lookupDefinition,
        createIdentifiers: identifiersInterface.createIdentifiers,
        createEventPayload: createEventPayload,
        sendToClient: sendToClient,
        getDebug: getDebug,
        getEmail: getEmail,
        getHubId: getHubId,
        getHstc: getHstc,
        getLang: getLang,
        reportError: reportError,
        logError: logError,
        logMessage: logMessage
      }].concat(args));
    }
  };
};